import Template from "../Template";

const template = new Template({
  templatePath: window.digiteketData.themeUrl + "/tpls",
});

export default template;
